/**
 * InstitutionalFlowRuntime.tsx -- MER Algo Footprints
 *
 * Phase 1 hardening: decouples institutional flow fetching from the
 * FlowDebugPanel. Previously the panel itself drove polling via
 * useFlowSignal(open ? activeSymbol : null) -- meaning if a user never
 * opened the debug panel, the AI thesis sidecar (setLiveFlowContext) was
 * never populated and the INSTITUTIONAL FLOW prompt section was silent.
 *
 * This runtime is headless. It subscribes to the active symbol from the
 * store and runs useFlowSignal unconditionally. The hook writes to the
 * existing sidecar (promptBuilder.setLiveFlowContext), so the AI thesis
 * always sees current flow context regardless of panel visibility.
 *
 * FlowDebugPanel becomes display-only -- it reads from the same sidecar
 * via subscribeFlowContext / getLiveFlowContext.
 */
import { useStore } from '../../store';
import { useFlowSignal } from '../../hooks/useFlowSignal';

export function InstitutionalFlowRuntime() {
  const activeSymbol = useStore(s => s.activeSymbol);
  // Drive flow polling for the active symbol. useFlowSignal handles
  // null/empty, visibility gating, market-hours check, and sidecar writes.
  useFlowSignal(activeSymbol);
  return null;
}
